module.exports = __webpack_public_path__ + "media/images/icons/check-form-832faa87133d975fdcb551090cc76f2b.svg";